/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import classNames from 'classnames';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';

class ConfirmSupplierModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reasonIsRequired: false
    }
  }

  onConfirmContinue = () => {
    const { onContinueAction } = this.props
    const { justification } = this.state
    if (!justification) return this.setState({reasonIsRequired: true})
    return onContinueAction(justification)

  }

  
  render () {
    const { t, display, onHidden, btnSubmitLoading, data } = this.props
    const { reasonIsRequired } = this.state
    const renderValues = data.map(item => (
      <div className='' key={item.key} className="p-col-6">
        <label className="p-text-bold">{item.label}</label><br/>
        <label>{item.value}</label>
      </div>
    ))

    const children = (
      <div className="p-mt-2 p-fluid" >
        <div className='p-grid'>
          <p className='p-col-12'> ¿Estas seguro de realizar los siguientes cambios? </p>
          {renderValues}
          <div className='p-col-12'>
            <label className="">{t('Justificación del cambio')}</label>
            <InputTextarea
            name="justification"
            onChange={(e) =>
              this.setState({ justification: e.target.value }, () => this.setState({reasonIsRequired: false}))
            }
            rows={5}
            cols={30}
            className={classNames({
              'p-invalid': reasonIsRequired,
            })}
          />
          {reasonIsRequired && <small className="p-error">{`${t('Justificación del cambio')} ${t('es requerido')} `}</small>}
          </div>
          
        </div>
        <div className="p-dialog-footer custom">
          <div>
            <Button
              label={t('Cancelar')}
              type="button"
              className="p-button-raised p-button-text p-button-plain"
              onClick={() => onHidden()}
            />
            <Button
              label={t('Aceptar')}
              type="submit"
              className="p-button-success"
              onClick={() => this.onConfirmContinue()}
              loading={btnSubmitLoading}
            />
          </div>
        </div>
      </div>
    )
    return (
      <Dialog
        header={t('Confirmar cambios para proveedor')}
        visible={display}
        breakpoints={{'960px': '90vw'}}
        style={{ width: '50vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}



export default compose(
  withTranslation()(ConfirmSupplierModal))